import * as React from 'react';
import { ca } from '@cian/analytics';
export function useTracking(_ref) {
  var newbuildingId = _ref.newbuildingId,
    pageTypeJK = _ref.pageTypeJK,
    houseId = _ref.houseId;
  var page = React.useMemo(function () {
    var isSeoPage = pageTypeJK === 'Seo';
    var pageType = isSeoPage ? 'Normal' : pageTypeJK;
    var extra = {
      PageTypeJK: pageType
    };
    if (isSeoPage) {
      extra.is_seo = true;
    }
    return {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: extra
    };
  }, [pageTypeJK]);
  var trackOfferLinkClick = React.useCallback(function (action) {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_JK',
      action: action,
      label: 'layout',
      page: page,
      products: [{
        id: newbuildingId,
        offertype: 'JK',
        extra: {
          room_num: null,
          corpus_id: houseId || null
        }
      }]
    });
  }, [page, newbuildingId, houseId]);
  var trackOffersModalOpen = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Finishing',
      action: 'show_sopr',
      label: 'modal_open',
      page: page
    });
  }, [page]);
  var trackModalOfferLinkClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Finishing',
      action: 'click_sopr',
      label: 'modal_open_card',
      page: page
    });
  }, [page]);
  var trackModalListingLinkClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Finishing',
      action: 'click_sopr',
      label: 'modal_open_listing_jk',
      page: page
    });
  }, [page]);
  return React.useMemo(function () {
    return {
      trackOfferLinkClick: trackOfferLinkClick,
      trackOffersModalOpen: trackOffersModalOpen,
      trackModalOfferLinkClick: trackModalOfferLinkClick,
      trackModalListingLinkClick: trackModalListingLinkClick
    };
  }, [trackOfferLinkClick, trackOffersModalOpen, trackModalOfferLinkClick, trackModalListingLinkClick]);
}